import React from 'react';
import ThingsToKnow from '../ThingsToKnow/ThingsToKnow';
import styles from './ContentList.module.css';

export type ContentSection = {
  title?: string;
  intro?: string;
  content?: string;
};

type ContentListProps = {
  contentList: ContentSection[];
};

const ContentList = ({ contentList }: ContentListProps) => {
  if (!contentList?.length) {
    return null;
  }

  return (
    <>
      {contentList.map((section, index) => (
        <section
          key={`${section.title || 'content'}_${index}`}
          className="visibilityAuto"
        >
          {section.title ? <h2>{section.title}</h2> : null}
          {section.intro ? (
            <p className={`${styles.intro} appendBottom20`}>{section.intro}</p>
          ) : null}
          {section.content ? <ThingsToKnow html={section.content} /> : null}
        </section>
      ))}
    </>
  );
};

export default ContentList;
